import React from "react";
import { viewRegistry, withToolbar } from "sulu-admin-bundle/containers";

import CountingRowsView from "./CountingRowsView";
import ReportView from "./ReportView";
import HeaderView from "./Header/HeaderView";
import PlayerRecapPage from "../components/PlayerRecapTable/PlayerRecapPage";
import PrivacyPolicySettingsView from "../privacy/PrivacyPolicySettingsView";

class PlayerRecapPageView extends React.Component {
    render() {
        return <PlayerRecapPage {...this.props} />;
    }
}

const PlayerRecapPageWithToolbar = withToolbar(PlayerRecapPageView, function () {
    const { router } = this.props;
    return {
        backButton: {
            onClick: () => {
                const fromView = router.attributes.fromView;
                if (!fromView) return;
                router.restore(fromView, {
                    locale: router.attributes.locale,
                    id: router.attributes.teamId,
                });
            },
        },
    };
});

const registerViews = () => {
    viewRegistry.add("count_rows", CountingRowsView);
    viewRegistry.add("app.header_view", HeaderView);
    viewRegistry.add("app.report_view", ReportView);
    viewRegistry.add("player_recap_detail", PlayerRecapPageWithToolbar);
    viewRegistry.add("app.privacy_policy_settings", PrivacyPolicySettingsView);
};

export default registerViews;
